import React, { forwardRef } from 'react'
import styles from './EntryButton.module.css'
import { EntryButtonProps } from './types'

export const EntryButton = forwardRef<HTMLDivElement, EntryButtonProps>(({
    disabled = false,
    isSubmitting = false,
    dataClickLabel,
    onClick,
    disabledIconSrc,
}, ref) => {
    // DEV-3061: 非活性時グレーアイコン
    const iconSrc = disabled && disabledIconSrc
        ? disabledIconSrc
        : '/renewal_lp/Cta/completelyFreeIcon.png'
    return (
        <div className={styles.buttonContainer} ref={ref}>
            <button
                className={`${styles.entryButton} ${isSubmitting ? styles.pressed : ''}`}
                disabled={disabled}
                data-click-label={dataClickLabel}
                onClick={onClick}
                type='submit'
            >
                <img
                    src={iconSrc}
                    alt={'エントリーボタンアイコン'}
                    className={styles.entryIcon}/>
                <div className={styles.mainText}>
                    <div className={styles.subText}>利用規約に同意の上</div>
                    <div className={styles.primaryText}>求人を紹介してもらう</div>
                </div>
                <div className={styles.entryArrow}><img src={'/renewal_lp/Cta/rightArrow.svg'} /></div>
            </button>
        </div>
    )
})
